import { supabase } from './client';
import { logActivity } from './activities';
import { getProfileById } from './profiles';

export const subscribeToUser = async (followerId: string, publisherId: string) => {
  const { data, error } = await supabase
    .from('user_subscriptions')
    .insert({ follower_id: followerId, publisher_id: publisherId })
    .select()
    .single();

  if (error) {
    console.error('Error subscribing to user:', error);
    throw error;
  }

  const publisherProfile = await getProfileById(publisherId);
  const publisherUsername = publisherProfile?.username || 'un usuario';

  await logActivity(
    followerId,
    'followed_user',
    `Empezaste a seguir a @${publisherUsername}.`,
    `/${publisherUsername}`,
    publisherId
  );

  return data;
};

export const unsubscribeFromUser = async (followerId: string, publisherId: string) => {
  const { error } = await supabase
    .from('user_subscriptions')
    .delete()
    .eq('follower_id', followerId)
    .eq('publisher_id', publisherId);

  if (error) {
    console.error('Error unsubscribing from user:', error);
    throw error;
  }
};

export const checkIfFollowing = async (followerId: string, publisherId: string): Promise<boolean> => {
  const { data, error } = await supabase
    .from('user_subscriptions')
    .select('id')
    .eq('follower_id', followerId)
    .eq('publisher_id', publisherId)
    .single();

  if (error && error.code !== 'PGRST116') {
    console.error('Error checking if following:', error);
    throw error;
  }
  return !!data;
};

export const checkIfFollowsBack = async (currentUserId: string, viewedUserId: string): Promise<boolean> => {
  const { data, error } = await supabase
    .from('user_subscriptions')
    .select('id')
    .eq('follower_id', viewedUserId)
    .eq('publisher_id', currentUserId)
    .single();

  if (error && error.code !== 'PGRST116') {
    console.error('Error checking if follows back:', error);
    throw error;
  }
  return !!data;
};

export const getUserSubscriptions = async (followerId: string): Promise<string[]> => {
  const { data, error } = await supabase
    .from('user_subscriptions')
    .select('publisher_id')
    .eq('follower_id', followerId)
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching user subscriptions:', error);
    throw error;
  }
  return data.map(sub => sub.publisher_id);
};

export const getUserFollowers = async (publisherId: string): Promise<string[]> => {
  const { data, error } = await supabase
    .from('user_subscriptions')
    .select('follower_id')
    .eq('publisher_id', publisherId)
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching user followers:', error);
    throw error;
  }
  return data.map((sub: any) => sub.follower_id);
};